export default class Form {

  constructor() {
    const serviceSettingsLabel = document.getElementById('service_settings__url_help'),
    upgradeButton = document.querySelector('.upgrade_deployment');

    if (serviceSettingsLabel) {
      this.serviceSettingsLabel = serviceSettingsLabel;
      this.serviceHelpLabels();
    }
    if (upgradeButton) {
      this.upgradeButton = upgradeButton;
      this.upgradeService();
    }
  }

  serviceHelpLabels() {
    const parent = this.serviceSettingsLabel.parentNode,
    label = parent.querySelector('label'),
    inputs = document.querySelectorAll('input[type="text"]');

    parent.classList.add('mt-4');
    parent.insertBefore(this.serviceSettingsLabel, parent.querySelector('input[type="text"]'));

    if (label) {
      label.classList.add('m-0');
    }

    if (inputs) {
      inputs.forEach(el => {
        const parent = el.parentNode;
        parent.classList.add('form-group');
      });
    }
  }

  upgradeService() {
    const errorLabel = document.querySelector('.error');
    if (this.upgradeButton) {
      this.upgradeButton.addEventListener('click', () => {
        const confirmInput = document.getElementById('confirm_upgrade');
        const select = document.getElementById('upgrade_version');
        const value = select.options[select.selectedIndex].value;

        if (confirmInput && confirmInput.value === 'UPGRADE') {
          errorLabel.classList.add('d-none');
          errorLabel.classList.remove('d-block');
          const { url, redirect } = confirmInput.dataset;
          $.ajax({
            url: url,
            type: 'post',
            data: {
              'target_version_id': value,
            },
            dataType: 'json',
            success: function() {
              top.document.location = redirect;
              top.closeAction();
            },
          });
        }
        else {
          errorLabel.classList.remove('d-none');
          errorLabel.classList.add('d-block');
        }
      });
    }
  }
}
